// Shared blog helpers used by the public pages, admin editor, and server.

/** Estimated reading time in minutes from markdown (200 wpm). */
export function readingTimeMinutes(markdown: string | null | undefined): number {
  const words = (markdown || '').trim().split(/\s+/).filter(Boolean).length
  return Math.max(1, Math.round(words / 200))
}

/** URL-safe slug from a post title. */
export function slugifyTitle(title: string): string {
  const slug = (title || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80)
    .replace(/-+$/g, '')
  return slug || 'post'
}

export interface BlogPost {
  id: string
  slug: string
  title: string
  excerpt: string | null
  content: string
  cover_image_url: string | null
  tags: string[]
  status: 'draft' | 'published'
  meta_description: string | null
  published_at: string | null
  created_at: string
  updated_at: string
}
